import React from "react";
import { useTranslation } from "react-i18next";
import LabelText from "../../shared/LabelValueFormatters/LabelText";
import Checkbox from "@mui/material/Checkbox";
import makeStyles from "@mui/styles/makeStyles";

interface ReportingChartCheckboxProps {
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
}

const useStyles = makeStyles({
  reportCheckboxDiv: {
    marginTop: "-25px",
  },
});

interface ReportCheckboxDivProps {
  children: React.ReactNode;
}

const ReportCheckboxDiv: React.FC<ReportCheckboxDivProps> = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.reportCheckboxDiv}>{children}</div>;
};

export function ReportingChartCheckbox(props: ReportingChartCheckboxProps) {
  const { t } = useTranslation();
  const { isChecked, onChange } = props;

  return (
    <LabelText>
      <ReportCheckboxDiv>
        <Checkbox checked={isChecked} onChange={(e) => onChange(e.target.checked)} />
        {t("reporting.reportChartInclude")}
      </ReportCheckboxDiv>
    </LabelText>
  );
}
